module.exports = "/_next/static/images/RepeatPurchaseCampaignsDesktop-60aaacc5ebfbabcac6426798bbefeedf.webp";